import { FC, useEffect, useState } from "react";
import "./SidebarChatsListFilter.scss";
import SidebarFilter from "../../../../components/SidebarFilter/SidebarFilter";
import moment from "moment";
import { useForm } from "react-hook-form";
import { Col, FormGroup, Row } from "react-bootstrap";
import InputDateRange from "../../../../components/InputDateRange/InputDateRange";
import InputSearchPartner from "../../../InputSearchPartner/InputSearchPartner";
import { useChatsHistory } from "../../../../providers/Chats/ChatsHistoryProvider";
import { ChatsStatusEnum } from "../../../../enums/Chat/ChatStatusEnum";
import ReactSelect from "react-select";
import { customStyles } from "../../../../models/SelectCustomStyles";

interface SidebarChatsListFilterProps {}

const userTypeOptions = [
  { value: 1, label: 'Parceiro' },
  { value: 0, label: 'Operacional' },
];

const chatStatusOptions = [
  { value: ChatsStatusEnum.EM_ANDAMENTO, label: 'Em andamento' },
  { value: ChatsStatusEnum.FINALIZADO, label: 'Finalizado' },
];

// @ts-ignore
export const defaultValues = {
  chat_id: null,
  user_id: null,
  user_name: null,
  chat_status: null,
  date_min: null,
  date_max: null,
  user_keyword: null,
  agent_keyword: null,
} as any;

const SidebarChatsListFilter: FC<SidebarChatsListFilterProps> = () => {
  const { handleSubmit, register, setValue, control } = useForm<any>({
    defaultValues,
  });
  const { setParams } = useChatsHistory();
  const [valuePartner, setValuePartner] = useState<any>();
  const [dateMin, setDatemin] = useState<any>("");
  const [dateMax, setDateMax] = useState<any>("");
  const [userFilterType, setUserFilterType] = useState<'code' | 'name'>('code');
  const [selectedUserType, setSelectedUserType] = useState<any | null>(null);
  const [selectedChatStatus, setSelectedChatStatus] = useState<any | null>(null);

  useEffect(() => {
    setValue("user_id", valuePartner?.value);
  }, [valuePartner]);

  const onSubmit = async (data: any) => {
    const {
      page: _page,
      perPage: _perPage,
      withPaginate: _withPaginate,
    } = data;
    const filter: any = {
      chat_id: data?.chat_id || null,
      user_id: userFilterType === 'code' ? (data?.user_id?.value || null) : null,
      date_min: dateMin ? moment(dateMin).format("YYYY-MM-DD") : null,
      date_max: dateMax ? moment(dateMax).format("YYYY-MM-DD") : null,
      user_keyword: data?.user_keyword || null,
      agent_keyword: data?.agent_keyword || null,
    };

    if (userFilterType === 'name' && data?.user_name) filter.user_name = data.user_name;
    if (selectedChatStatus !== null) filter.chat_status = selectedChatStatus.value;
    if (selectedUserType !== null) filter.commissioned = selectedUserType.value;

    setParams((prev: any) => {
      const merged: any = { ...(prev?.filter ?? {}), ...filter };
      if (!filter.user_name) delete merged.user_name;
      if (!filter.chat_status) delete merged.chat_status;
      if (filter.commissioned === undefined) delete merged.commissioned;
      return {
        ...prev,
        filter: merged,
        page: 1,
        perPage: prev?.perPage ?? 10,
        withPaginate: prev?.withPaginate ?? true,
      };
    });
  };

  return (
    <SidebarFilter handleSubmit={handleSubmit(onSubmit)}>
      <div
        className="SidebarChatsListFilter"
        data-testid="SidebarChatsListFilter"
      >
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="chat_id">#ID</label>
              <input
                type="number"
                className="form-control"
                {...register("chat_id")}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label>USUÁRIO</label>
              <div className="d-flex align-items-center gap-3 mb-2">
                <div className="d-flex align-items-center gap-1">
                  <input
                    type="checkbox"
                    id="filterByCode"
                    checked={userFilterType === 'code'}
                    onChange={() => setUserFilterType('code')}
                  />
                  <label htmlFor="filterByCode" className="mb-0" style={{ cursor: 'pointer', fontSize: 12 }}>Filtrar por Código</label>
                </div>
                <div className="d-flex align-items-center gap-1">
                  <input
                    type="checkbox"
                    id="filterByName"
                    checked={userFilterType === 'name'}
                    onChange={() => setUserFilterType('name')}
                  />
                  <label htmlFor="filterByName" className="mb-0" style={{ cursor: 'pointer', fontSize: 12 }}>Filtrar por Nome</label>
                </div>
              </div>
              {userFilterType === 'code' && (
                <InputSearchPartner
                  name="user_id"
                  control={control}
                  setValue={setValue}
                  valuePartner={valuePartner}
                  setValuePartner={setValuePartner}
                />
              )}
              {userFilterType === 'name' && (
                <input
                  type="text"
                  className="form-control"
                  {...register("user_name")}
                />
              )}
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label>STATUS DA CONVERSA</label>
              <ReactSelect
                isClearable
                options={chatStatusOptions}
                value={selectedChatStatus}
                placeholder="Todos"
                className="form-control p-0"
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(e) => setSelectedChatStatus(e ?? null)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label>TIPO DE USUÁRIO</label>
              <ReactSelect
                isClearable
                options={userTypeOptions}
                value={selectedUserType}
                placeholder="Todos"
                className="form-control p-0"
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(e) => setSelectedUserType(e ?? null)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <InputDateRange
              startDate={dateMin}
              setStartDate={setDatemin}
              endDate={dateMax}
              setEndDate={setDateMax}
              setValue={setValue}
              startLabelText={"DATA MÍNIMA"}
              endLabelText={"DATA MÁXIMA"}
            />
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="user_keyword">PERGUNTA</label>
              <textarea
                className="form-control"
                rows={5}
                {...register("user_keyword")}
              ></textarea>
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="agent_keyword">RESPOSTA</label>
              <textarea
                className="form-control"
                rows={5}
                {...register("agent_keyword")}
              ></textarea>
            </FormGroup>
          </Col>
        </Row>
      </div>
    </SidebarFilter>
  );
};

export default SidebarChatsListFilter;
